import styled from 'styled-components/macro';

export const ListContainer = styled.div`
	position: relative;
`;

export const PersonWrapper = styled.div`
	min-height: 100%;
	margin-bottom: 10px;
	margin-top: 30px;
`;

export const TimeRegsTableWrapper = styled.div`
	display: inline-block;
	min-width: 100%;
	margin-bottom: 10px;
	margin-right: 66px;
	border-collapse: separate;
`;

export const TimeRegsListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	align-items: stretch;
	min-height: 100%;
	margin-bottom: 32px;
`;

export const PageContent = styled.div`
	margin-left: 22px;
	margin-right: 22px;
`;

export const TableHeaderWrapper = styled.div`
	padding-left: 66px;
	padding-right: 66px;
	position: relative;
`;

export const BlurryContainer = styled.div`
	box-sizing: border-box;
	justify-content: stretch;
	display: flex;
	flex-direction: column;
	/* padding-left: 100px; */
`;

export const BlurryLine = styled.div`
	display: flex;
	flex-direction: row;
	padding-right: 16px;

	.blurry-text {
		color: #a1a1a1;
		font-size: 13px;
		font-weight: 400;
		line-height: normal;
		filter: blur(4px);
		width: 166px;
		height: 35px;
		text-align: center;
	}
`;

export const BlurryLineBottomOne = styled.div`
	display: flex;
	flex-direction: row;
	padding-right: 16px;
	height: 28px;

	.blurry-text {
		color: #a1a1a1;
		font-size: 13px;
		font-weight: 400;
		line-height: normal;
		filter: blur(4px);
		width: 166px;
		text-align: center;
	}
`;
export const BottomTwoLoadMoreWrapper = styled.div`
	position: relative;
	margin-top: 2px;
	margin-bottom: 2px;
	height: 120px;

	.button-wrapper {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

export const BottomOneLoadMoreWrapper = styled.div`
	position: relative;
	margin-top: 8.5px;
	margin-bottom: 5px;
	height: 120px;

	.button-wrapper {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;

export const ListAndButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;
